import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type GSCIntegrationRequest as SchemaGSCIntegrationRequest } from '../schemas/GSCIntegrationRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Интеграция с Google Search Console
 */
export const GSCIntegrationContentType = 'application/json' as const;
export type GSCIntegrationRequest = SchemaGSCIntegrationRequest;
export type GSCIntegrationResponses = LinkCommonErrorResponses & {};
export type GSCIntegrationResponseSuccess = undefined;
export type GSCIntegrationSearchParams = undefined;
export type GSCIntegrationPathParameters = undefined;
export const GSCIntegrationUrl = '/gsc/integration' as const;
export const GSCIntegrationMethod = 'POST' as const;
export const getGSCIntegrationUrl = (_params?: GSCIntegrationPathParameters) => GSCIntegrationUrl;
